import Vue from 'vue'
import App from './App.vue'

import store from './store'
import router from './router'

import Amplify, * as AmplifyModules from 'aws-amplify'
import { Hub, Auth } from 'aws-amplify'
import {
  AmplifyPlugin,
  AmplifyEventBus
} from 'aws-amplify-vue'
import AwsExports from './aws-exports'

Amplify.configure(AwsExports)
Vue.use(AmplifyPlugin, AmplifyModules);

import Buefy from 'buefy'
Vue.use(Buefy)

import Authentication from './plugins/authentication'
Vue.use(Authentication)

// Amplify.Logger.LOG_LEVEL = 'DEBUG'

Vue.config.productionTip = false

const fetchProfile = async () => {
  const user = store.state.user
  const profile = await store.dispatch('profile.get', user.username)
  if (profile) {
    console.log('found profile:', profile.id)
  } else {
    await store.dispatch('profile.create', {
      userID: user.id,
      username: user.username,
      bio: ''
    })
  }
}

const fetchUser = async () => {
  try {
    const user = await Auth.currentAuthenticatedUser()
    const credentials = await Auth.currentUserCredentials()
    store.commit('currentUser.set', { user, credentials })
    await fetchProfile()
  } catch (e) {
    // not authenticated
    console.warn(e)
  }
}

fetchUser()

AmplifyEventBus.$on('authState', async (info) => {
  console.log(info)
  switch (info) {
    case 'signedOut':
      store.commit('currentUser.set', {})
      router.replace('/')
      break
    case 'signedIn':
      await fetchUser()
      // DataStore.clear()

      break
  }
})

Hub.listen('datastore', async hubData => {
  // const  { event, data } = hubData.payload;
  console.log(hubData)
})

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
